module.exports = __webpack_public_path__ + "img/chips5000.f7dc5ec5.webp";